
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import {  Link } from "react-router-dom";
import Box from '@material-ui/core/Box';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import InputAdornment from '@material-ui/core/InputAdornment';
import { InputBase } from '@material-ui/core';


function Copyright() {
  return (
    <Typography variant="body2" style={{color: 'black', fontFamily: 'Poppins'}}>      
       <Link to='/privacypolicy' style={{textDecoration: 'none', color: 'black'}}>Privacy Policy |</Link>
       <Link to='/termsofuse' style={{textDecoration: 'none', color: 'black'}}> Terms of Use | </Link>
       <Box display={{ xs: 'block', sm: 'none' }}><br/></Box>
      {'Copyright ©     '}
      <Link to='/' color="inherit" 
      style={{textDecoration: 'none', color: 'black'}}>
         Sea-Land Distributors, LLC. 
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
function handleClick(e) {
  e.preventDefault();
  alert('Thankyou! Your email has been recieved');
}
const useStyles = makeStyles(theme => ({
    '@global': {
      ul: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
      },
    },
    footer: {   
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(3),
      [theme.breakpoints.up('sm')]: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
      },
    },
    headerlink:{
      textDecoration: 'none',
      color: 'black',
      fontFamily: 'Poppins',
      fontSize: '25px',
  },
    link:
    {
      textDecoration: 'none',
      color: 'black',
      fontSize: '16px',
      fontFamily: 'Poppins'
    },
    textfield:{
      margin: '5px',
      backgroundColor: 'white',
      color: 'black',
      borderRadius: '20px',
      paddingLeft: '8px'
  },
    signup:{
      color: 'white', 
      border: '2px solid white', 
      padding: '4px',
      margin: '3px',
    }, 
  }));

export default function Footer() {
  const classes = useStyles(); 
  return (
    <div style={{backgroundColor: '#fff100', borderTop: '1px solid #e4e4e4'}}>
    <Container maxWidth="lg" component="footer" className={classes.footer} >
        <Grid container spacing={2}>        
            <Grid item xs={6} sm={3} md={4} lg={4} >
              <Typography gutterBottom className={classes.headerlink}>
              Pro-Lift Fittings</Typography>
              <ul>    
              <Link to='/' className={classes.link}><li>Home  </li></Link>  
              <a href='/#contact' className={classes.link}><li>Contact  </li> </a>  
              <a href='/#about' className={classes.link}><li>About </li> </a>
              <a href='/#wheretobuy' className={classes.link}><li>Where to Buy </li>  </a>
              <a href='/#products' className={classes.link}><li>Products </li>  </a>               
              </ul>
            </Grid>  
            <Grid item xs={6} sm={3} md={4} lg={4}>
              <Typography gutterBottom className={classes.headerlink}>                
              Quick Links
              </Typography>                 
              <ul>
              <Link to='/carbonsteelblocks' className={classes.link}><li>Nav 1</li></Link>                    
              <Link to='/stainlesssteelblocks' className={classes.link}><li>Nav 2</li></Link>
              <Link to='/sheaves' className={classes.link}><li>Nav 3  </li></Link>
              </ul>              
            </Grid>  
            <Grid item xs={12} sm={6} md={4} lg={4}>
            <Typography className={classes.headerlink} style={{paddingLeft:'5px', paddingBottom: '5px'}}> N E W S L E T T E R</Typography>             
            <Typography className={classes.link} style={{paddingLeft:'5px'}}>Sign up for new  Pro-Lift  releases</Typography>                       
            <form >
            <InputBase className={classes.textfield}
              inputProps={{ 'aria-label': 'naked' }}      
              endAdornment={
                <InputAdornment position="end">
                <ArrowRightIcon fontSize='large' onClick={handleClick} style={{cursor:'pointer'}}>
                  </ArrowRightIcon>
                </InputAdornment>
              }
            />
           </form>  
        </Grid>
        </Grid>
        <Box mt={5}>
          <Copyright />
        </Box>
        <div style={{marginBottom: '30px'}}></div>
      </Container>
      </div>
  );
}